// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"92fdcbcc","632":"fe331d2e"}[chunkId] + ".chunk.css";
};